import React from "react";
import { BemHelper } from "@/utils/BemHelper";
import classNames from "classnames";
import { ThemeFontVariant } from "../types";
import { THEME_FONT_VARIANTS } from "../constants";

export type CtPageWrapperProps = {
  children?: React.ReactNode;
  fontVariant?: ThemeFontVariant;
};

const bem = new BemHelper("ct-page-wrapper");

function CtPageWrapper({ children, fontVariant }: CtPageWrapperProps) {
  return (
    <div
      className={classNames(
        bem.block(),
        bem.modifier(fontVariant || THEME_FONT_VARIANTS.FONT_VARIANT_1),
      )}
    >
      {children}
    </div>
  );
}

CtPageWrapper.defaultProps = {
  fontVariant: THEME_FONT_VARIANTS.FONT_VARIANT_1,
};

export default CtPageWrapper;
